import { render } from "./Dust.vue?vue&type=template&id=def83e86"
import script from "./Dust.vue?vue&type=script&lang=js"
export * from "./Dust.vue?vue&type=script&lang=js"
script.render = render

export default script